import { render, staticRenderFns } from "./SincronizarImagens.vue?vue&type=template&id=27bb65d6&scoped=true"
import script from "./SincronizarImagens.vue?vue&type=script&lang=js"
export * from "./SincronizarImagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb65d6",
  null
  
)

export default component.exports